"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pescaglia": {
    "da0466e2": [{
      "hkey": "84ad32d8",
      "slug": "san-martino-in-freddana-monsagrati",
      "name": "San Martino in Freddana-Monsagrati",
      "primary": true,
      "skipSearch": false
    }],
    "monsagrati": [{
      "hkey": "84ad32d8",
      "slug": "san-martino-in-freddana-monsagrati",
      "name": "San Martino in Freddana-Monsagrati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pescaglia"
    }],
    "74802075": [{
      "hkey": "84ad32d8",
      "slug": "san-martino-in-freddana-monsagrati",
      "name": "San Martino in Freddana-Monsagrati",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-in-freddana": [{
      "hkey": "84ad32d8",
      "slug": "san-martino-in-freddana-monsagrati",
      "name": "San Martino in Freddana-Monsagrati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3abc6cc6": [{
      "hkey": "947b3a82",
      "slug": "pescaglia",
      "name": "Pescaglia",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco-in-turrite": [{
      "hkey": "947b3a82",
      "slug": "pescaglia",
      "name": "Pescaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;